export const ROUTES = {
  HOME_PATIENT: '/sessions',
};
